export const title = 'Downloads';

Quantidade de novas instalações do app.